import { session } from '@/utils/storage';
const { isCore } = JSON.parse(session.get('user-infor') || '{}');
export const routeConfig = {
  meta: {
    title: isCore ? '应收账款融资' : '',
  }
};
